// extracted by mini-css-extract-plugin
module.exports = {"button":"SettingsButton_button__1JnUs"};